import React, { ButtonHTMLAttributes } from 'react';
import { Button } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  height?: number;
  paddingVertical?: number;
  fontSize?: string;
  borderRadios?: string;
  color: string;
  block?: boolean;
  transform?: boolean;
  children: any;
  onClick(): void;
}

function ButtonComponent({
  height,
  color,
  children,
  onClick,
  fontSize,
  block,
  transform,
  borderRadios,
  paddingVertical,
  ...rest
}: ButtonProps) {
  return (
    <Button
      height={height}
      paddingVertical={paddingVertical}
      fontSize={fontSize}
      color={color}
      borderRadios={borderRadios}
      block={block}
      transform={transform}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
}
export default ButtonComponent;
